module.exports = __webpack_public_path__ + "media/images/background/background-2-c8e32cf4659f2c695417c0510b088376.jpg";